// The store tells the native shell only conclusive session changes, never a credential.
import { inMacShell, tellShell } from '../lib/shell'
import type { BoardStoreOptions } from '../store/store'

export function nativeSessionOptions(): Pick<BoardStoreOptions, 'onSessionState' | 'offlineSessionAllowed'> {
  if (!inMacShell()) return {}
  // Only an explicitly built unsigned app keeps the previous WebKit-only session.
  if (globalThis.document.documentElement.dataset.sessionMode === 'webkit-development') return {}
  const document = globalThis.document.documentElement.dataset.sessionDocument
  if (!document) return { offlineSessionAllowed: false }
  let revision = 0
  return {
    offlineSessionAllowed: globalThis.document.documentElement.dataset.sessionPresent === '1',
    onSessionState: (state) => tellShell({ sessionState: { document, revision: ++revision, state } }),
  }
}
